import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import moment from 'moment-timezone';
import { forwardRef } from 'react';
import { colors } from 'ui/theme';
import { useTimeFiltersContext } from '../context';

if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

export const AudienceRetentionStackChart = forwardRef(({ label, data }, ref) => {
  const { timezone } = useTimeFiltersContext();
  const options = {
    chart: {
      type: 'area',
    },
    title: {
      text: undefined,
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        minute: '%l:%M%P',
        hour: '%l:%M%P', // 1:05pm
        day: '%b %e', // June 6
      },
    },
    credits: {
      enabled: false,
    },
    yAxis: {
      min: 0,
      minRange: 1,
      title: {
        text: undefined,
      },
      labels: {
        format: '{value}',
      },
    },
    exporting: {
      enabled: false,
    },
    tooltip: {
      xDateFormat: '%b %e',
      pointFormat: `<span>{series.name}:</span> <b>{point.y}</b><br/>`,
      backgroundColor: colors.grey80,
      style: {
        color: colors.white,
      },
    },
    plotOptions: {
      area: {
        lineWidth: 1.5,
        lineColor: colors.cyan80,
        fillColor: {
          linearGradient: [0, 0, 0, 300],
          stops: [
            [0, colors.cyan80],
            [1, Highcharts.color(colors.cyan80).setOpacity(0).get('rgba')],
          ],
        },
      },
    },
    series: [
      {
        name: label,
        data,
      },
    ],
  };

  if (timezone) {
    // Highchart use moment to deduce timezone offset.
    window.moment = moment;
    options.time = {
      timezone,
    };
  }

  return (
    <HighchartsReact options={options} ref={ref} containerProps={{ style: { width: '100%' } }} />
  );
});
